/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface RegistrationRequest
 */
export interface RegistrationRequest {
  /**
   * Имя пользователя (минимум 2 символа)
   * @type {string}
   * @memberof RegistrationRequest
   */
  name: string
  /**
   * Электронная почта (уникальная, домен с MX-записью)
   * @type {string}
   * @memberof RegistrationRequest
   */
  email: string
  /**
   * Пароль (минимальная длина — server-options.password_min_length)
   * @type {string}
   * @memberof RegistrationRequest
   */
  password: string
  /**
   * Телефон (уникальный)
   * @type {string}
   * @memberof RegistrationRequest
   */
  phone: string
  /**
   * Идентификатор клиента из UTM-трекинга (seo)
   * @type {string}
   * @memberof RegistrationRequest
   */
  utmClientId?: string | null
  /**
   * Промокод из UTM-ссылки (seo; фиксируется middleware promo_code)
   * @type {string}
   * @memberof RegistrationRequest
   */
  promocode?: string | null
}

/**
 * Check if a given object implements the RegistrationRequest interface.
 */
export function instanceOfRegistrationRequest(
  value: object
): value is RegistrationRequest {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('email' in value) || value['email'] === undefined) return false
  if (!('password' in value) || value['password'] === undefined) return false
  if (!('phone' in value) || value['phone'] === undefined) return false
  return true
}

export function RegistrationRequestFromJSON(json: any): RegistrationRequest {
  return RegistrationRequestFromJSONTyped(json, false)
}

export function RegistrationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistrationRequest {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    email: json['email'],
    password: json['password'],
    phone: json['phone'],
    utmClientId: json['utmClientId'] == null ? undefined : json['utmClientId'],
    promocode: json['promocode'] == null ? undefined : json['promocode'],
  }
}

export function RegistrationRequestToJSON(
  value?: RegistrationRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    email: value['email'],
    password: value['password'],
    phone: value['phone'],
    utmClientId: value['utmClientId'],
    promocode: value['promocode'],
  }
}
